import config from '@/config';
import { NOTIFICATION_TYPES, generateNotificationItem } from '@/models/AppConfig';
import { AppState } from '@/models/TechnicianAppState';
import { UTILS_DEPENDENCIES, UtilsState } from '@/models/UtilsState';
import { STATE_MODULES } from '@/store/state-modules';
import axios, { AxiosResponse } from 'axios';
import { ActionContext } from 'vuex';
import { ConfigMutations } from '../config/mutations';
import { UtilsMutations } from './mutations';

export const UTILS_DATA_STORAGE_KEY = "utils_data"

export const UtilsActions = {
	LOAD_DEPENDENCIES: 'LOAD_DEPENDENCIES'
}

interface DependencyMap {
	[key: string]: Promise<any>
}

export default {
	async [UtilsActions.LOAD_DEPENDENCIES] (context: ActionContext<UtilsState, AppState>, payload: string[]) {
		try {
			const utilsData: {[key: string]: any} = context.state.data || {};
			const all: DependencyMap = payload.filter((dep: string) => !utilsData[dep]).reduce((acc: DependencyMap, dep: string) => {
				const dependency: Promise<any> | null = dependecyRequestMapping[dep]();
				if (!dependency) { // validate we have dependecy
					throw new Error(`cant load dependency ${dep}`);
				}
				acc[dep] = dependency;
				return acc;
			}, {})
	
			const keys = Object.keys(all);
			const values = await Promise.all(keys.map(key => all[key]));

			const result: { [key: string]: any } = {};
			keys.forEach((key: string, index: number) => {
				const tranformer = transformResposnse[key] || defaultResponseTransformer;
				result[key] = tranformer(values[index]);
			});

			context.commit(
				`${STATE_MODULES.UTILS}/${UtilsMutations.UPDATE_DEPENDENCIES}`,
				result,
				{ root: true }
			)
		} catch (error: any) {
			context.commit(
				`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
				generateNotificationItem({ type: NOTIFICATION_TYPES.error, message: (error as Error).message || "Something wnet wrong!" }),
				{ root: true }
			);
		}
	}
}

const dependecyRequestMapping: { [key: string] : any } = {
	[UTILS_DEPENDENCIES.MARKETS]: () => axios.get(`${config.api}/portal/market/list`),
	[UTILS_DEPENDENCIES.DEVICES]: () => axios.get(`${config.api}/portal/devices`)
}

const transformResposnse: { [key: string] : any } = {
	[UTILS_DEPENDENCIES.DEVICES]: (response: AxiosResponse<any>): any => response.data.devices
}

const defaultResponseTransformer = (response: AxiosResponse<any>): any => response.data
